import { BaseModel } from '@tcc-mono/shared/data-access';
import { Stable } from './stable.model';
import { Relation } from './relation.model';

export interface VionAnimal extends BaseModel {
  id: PropertyKey;
  country_code: string;
  identification_number: string;
  net_weight: string;
  gross_weight: string;
  weight_correction: string;
  category: string;
  europ: string;
  fat: string;
  ubn: string;
  delivery_date: string;
  description: string;
  vat_percentage: number;
  price_per_kg_ex_vat: number;
  cost_ex_vat: number;
  weide_toeslag_ex_vat: number;
  total_price_ex_vat: number;
  sale_price_per_kg_ex_vat: number;
  pricing_status: 'awaiting_price' | 'priced';
  slaughter_house: string;
  vion_order_id: number;
  created_at: string;
  updated_at: string;
  stable: {
    id: number;
    relation_id: number;
    relation: Relation;
    weide_toeslag: boolean;
  };
}
